(function() {
  'use strict';

  // ── ToC Sidebar Clone ──────────────────────────────────────────
  // 2026-09-02: inline ToC panel + collapsible/measured sidebar ToC.
  var DESKTOP_MQ = '(min-width: 65.6875rem)'; // must match the stacked-layout breakpoint in pl-article-body.liquid
  var MOBILE_MQ  = '(max-width: 699px)';
  var TOC_STATE_KEY = 'pl-toc-sidebar';

  function initToC() {
    var inlineNav = document.querySelector('#table-of-contents');
    var tocSlot = document.querySelector('.pl-article-body__toc-slot');
    var tocToggle = document.querySelector('.pl-article-body__toc-toggle');
    // NB: the Shopify section wrapper carries the same class as our inner div
    // (schema "class"), so select by the data attribute, not the class.
    var sectionRoot = document.querySelector('[data-inline-toc]');
    var inlineEnabled = !!(sectionRoot && sectionRoot.getAttribute('data-inline-toc') === 'true');

    if (!tocSlot) return;

    // The inline script in pl-article-body.liquid (right after the article
    // content) normally has already cloned the nav into the slot, removed the
    // inline original when the panel is off, and set the initial open state.
    // Fallback below covers the case where that script did not run.
    var cloned = tocSlot.querySelector('nav');
    if (!cloned) {
      if (!inlineNav) {
        // No ToC in article — hide the toggle container
        if (tocToggle) tocToggle.style.display = 'none';
        return;
      }
      cloned = inlineNav.cloneNode(true);
      cloned.removeAttribute('id');
      cloned.style.display = '';
      tocSlot.appendChild(cloned);
      if (!inlineEnabled) {
        // Legacy behaviour: REMOVE the inline nav from the DOM. (Using
        // `display: none` would keep it in the DOM and trigger Impact's
        // `.prose > * + *` adjacent-sibling margin rule on the first heading,
        // leaving a phantom gap above the first visible element.)
        inlineNav.remove();
        inlineNav = null;
      }
    }

    var highlight = initToCHighlight(cloned);

    if (inlineEnabled && inlineNav) {
      // Inline panel on: the original stays where the converter put it
      // (CSS shows it on desktop only). Clicks use the same smooth navigation
      // as the sidebar links; the sidebar ToC stays collapsed until the reader
      // has scrolled past the inline panel, then opens on its own.
      initInlineToC(inlineNav, tocToggle, highlight);
    }

    if (tocToggle) sidebarToc.init(tocToggle, cloned, inlineEnabled);
  }

  // ── Sidebar ToC controller ─────────────────────────────────────
  // Owns the <details>: animated open/close (height + opacity on the slot,
  // WAAPI, respects prefers-reduced-motion), the JS-measured nav height, and
  // the "user toggled manually → automatic off" flag.
  var sidebarToc = {
    details: null,
    summary: null,
    slot: null,
    nav: null,
    sidebar: null,
    animation: null,
    userToggled: false,

    init: function(details, nav, inlineEnabled) {
      this.details = details;
      this.summary = details.querySelector('summary');
      this.slot = details.querySelector('.pl-article-body__toc-slot');
      this.nav = nav;
      this.sidebar = details.closest('.pl-article-body__sidebar');

      var isMobile = window.matchMedia(MOBILE_MQ).matches;
      var desktop = window.matchMedia(DESKTOP_MQ).matches;
      // Mobile: collapsed. Desktop with inline panel: collapsed, auto-opens
      // once the reader scrolled past the panel. Desktop without: open.
      // Only when the inline prepare script did NOT already set the state —
      // otherwise this would slam a ToC shut that the reader opened before
      // this deferred script ran (seen on iPhone with long articles).
      if (!window.__plTocPrepared && (isMobile || (inlineEnabled && desktop))) {
        details.removeAttribute('open');
      }

      var self = this;
      if (this.summary) {
        this.summary.addEventListener('click', function(e) {
          e.preventDefault();
          self.userToggled = true;
          self.setOpen(!details.open, true);
        });
      }

      this.fit();
      window.addEventListener('resize', debounce(function() { self.fit(); }, 150));
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function() { self.fit(); });
      // Lazy sidebar images (author avatar / CTA image) can change the layout after init
      if (this.sidebar) {
        Array.from(this.sidebar.querySelectorAll('img')).forEach(function(img) {
          if (!img.complete) img.addEventListener('load', function() { self.fit(); }, { once: true });
        });
      }
    },

    // Nav max-height: let the nav take its full content height, read how far
    // the sidebar now overflows, and cap the nav by exactly that amount. No
    // margin arithmetic — the sticky CTA's `margin-top: auto` resolves to a
    // px value in getComputedStyle and would count as used space (rev 3 bug:
    // the cap collapsed to the 96px floor). Desktop only — the stacked layout
    // forces max-height:none in CSS. Needs the <details> open (closed content
    // has no layout); setOpen() re-runs it right after opening.
    fit: function() {
      if (!this.nav || !this.sidebar || !this.details) return;
      if (!window.matchMedia(DESKTOP_MQ).matches) {
        this.nav.style.maxHeight = '';
        return;
      }
      if (!this.details.open) return;
      this.nav.style.maxHeight = 'none';
      var full = this.nav.offsetHeight;
      var overflow = this.sidebar.scrollHeight - this.sidebar.clientHeight;
      var target = overflow > 0 ? full - overflow - 12 : full;
      this.nav.style.maxHeight = Math.max(96, Math.floor(target)) + 'px';
    },

    // Open/close with a height + opacity animation on the slot. `animate`
    // false = instant (used for the initial state).
    setOpen: function(open, animate) {
      var details = this.details, slot = this.slot;
      if (!details) return;
      if (details.open === open && !this.animation) return;

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!slot || !animate || reduce || typeof slot.animate !== 'function') {
        if (open) details.setAttribute('open', ''); else details.removeAttribute('open');
        if (open) this.fit();
        return;
      }

      if (this.animation) { this.animation.cancel(); this.animation = null; }
      var self = this;
      slot.style.overflow = 'hidden';

      if (open) {
        details.setAttribute('open', '');
        this.fit();
        var target = slot.scrollHeight;
        this.animation = slot.animate(
          [{ height: '0px', opacity: 0 }, { height: target + 'px', opacity: 1 }],
          { duration: 560, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
        );
        this.animation.onfinish = this.animation.oncancel = function() {
          slot.style.overflow = '';
          self.animation = null;
        };
      } else {
        var from = slot.getBoundingClientRect().height;
        this.animation = slot.animate(
          [{ height: from + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
          { duration: 400, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
        );
        this.animation.onfinish = function() {
          details.removeAttribute('open');
          slot.style.overflow = '';
          self.animation = null;
        };
        this.animation.oncancel = function() {
          slot.style.overflow = '';
          self.animation = null;
        };
      }
    }
  };

  // Inline panel: scroll-hint class when the list overflows its max-height,
  // click handling, and the "open the sidebar ToC after scrolling past" observer.
  function initInlineToC(inlineNav, tocToggle, highlight) {
    var list = inlineNav.querySelector('ul');

    function checkScrollable() {
      if (!list) return;
      var desktop = window.matchMedia(DESKTOP_MQ).matches;
      inlineNav.classList.toggle('is-scrollable', desktop && list.scrollHeight > list.clientHeight + 2);
    }
    checkScrollable();
    window.addEventListener('resize', debounce(checkScrollable, 150));
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(checkScrollable);

    Array.from(inlineNav.querySelectorAll('a[href^="#"]')).forEach(function(link) {
      bindTocLink(link, function(target) {
        if (highlight) highlight.lock(target.id);
        scrollToHeading(target, function() {
          if (highlight) highlight.unlock();
        });
      });
    });

    // Auto-open the sidebar ToC ONCE the inline panel has scrolled out above
    // the viewport, then stop observing — it never collapses again on its own
    // (QA feedback: re-collapsing on scroll-up was unwanted). The observer
    // fires immediately on observe(), so a deep link / hash landing that
    // starts below the panel opens the sidebar ToC right away. A manual
    // toggle before that switches the automatic off.
    if (tocToggle && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries) {
        if (sidebarToc.userToggled) { io.disconnect(); return; }
        if (!window.matchMedia(DESKTOP_MQ).matches) return;
        var entry = entries[entries.length - 1];
        var passed = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
        if (!passed) return;
        sidebarToc.setOpen(true, true);
        io.disconnect();
      }, { threshold: 0 });
      io.observe(inlineNav);
    }
  }

  function debounce(fn, wait) {
    var t;
    return function() {
      clearTimeout(t);
      t = setTimeout(fn, wait);
    };
  }

  // ── Smooth ToC navigation ──────────────────────────────────────
  // The theme has no `scroll-behavior: smooth`, so native hash clicks jump
  // instantly — and the lazy-image CLS correction used to fire *during* the
  // jump/scroll, which cancels any in-flight smooth scroll and lands hard
  // ("sometimes it scrolls nicely, sometimes it jumps"). ToC clicks now:
  // preventDefault → push the hash (no native jump) → one JS smooth scroll →
  // wait until scrolling has settled → correct drift (images that loaded on
  // the way) → only then arm the post-arrival image watcher.
  var SCROLL_SETTLE_MS = 120;
  var SCROLL_SAFETY_MS = 2500;

  function getDesiredTop(target) {
    var rootStyles = getComputedStyle(document.documentElement);
    var pad = parseFloat(rootStyles.scrollPaddingTop) || 0;
    var mar = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
    return pad + mar;
  }

  // Calls cb once window scrolling has come to rest: `scrollend` where
  // supported, otherwise a quiet period without scroll events. Safety-capped.
  function onScrollSettled(cb) {
    var done = false, quiet = null, safety = null;
    function finish() {
      if (done) return;
      done = true;
      clearTimeout(quiet);
      clearTimeout(safety);
      window.removeEventListener('scrollend', finish);
      window.removeEventListener('scroll', onScroll);
      cb();
    }
    function onScroll() {
      clearTimeout(quiet);
      quiet = setTimeout(finish, SCROLL_SETTLE_MS);
    }
    if ('onscrollend' in window) window.addEventListener('scrollend', finish, { once: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    quiet = setTimeout(finish, SCROLL_SETTLE_MS * 2); // nothing to scroll at all
    safety = setTimeout(finish, SCROLL_SAFETY_MS);
  }

  function scrollToHeading(target, onArrived) {
    var attempts = 0;
    function desiredScrollY() {
      return window.scrollY + target.getBoundingClientRect().top - getDesiredTop(target);
    }
    function arrive() {
      compensateClsToTarget(target); // images still loading above — post-arrival only
      if (onArrived) onArrived();
    }
    function go() {
      attempts++;
      var y = Math.max(0, Math.round(desiredScrollY()));
      if (Math.abs(y - window.scrollY) < 2) { arrive(); return; }
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: y, behavior: reduce ? 'instant' : 'smooth' });
      onScrollSettled(function() {
        var drift = target.getBoundingClientRect().top - getDesiredTop(target);
        if (Math.abs(drift) > 2 && attempts < 3) go(); else arrive();
      });
    }
    go();
  }

  // Intercepts a ToC link: keeps the URL hash in sync via pushState (no
  // native jump), then hands the target to `onNavigate(target)`.
  function bindTocLink(link, onNavigate) {
    link.addEventListener('click', function(e) {
      var id = link.getAttribute('href').slice(1);
      var target = document.getElementById(id);
      if (!target) return; // unknown anchor — let the browser handle it
      e.preventDefault();
      link.blur();
      try { history.pushState(null, '', '#' + id); } catch (err) { /* ignore */ }
      onNavigate(target);
    });
  }

  // ── Active Section Highlight ───────────────────────────────────
  // Returns a small controller so the inline panel can lock the sidebar
  // highlight onto a clicked entry while the page scrolls there.
  function initToCHighlight(tocNav) {
    var tocLinks = Array.from(tocNav.querySelectorAll('a[href^="#"]'));
    if (!tocLinks.length) return null;

    var headingIds = tocLinks.map(function(a) {
      return a.getAttribute('href').slice(1);
    });

    var headings = headingIds.map(function(id) {
      return document.getElementById(id);
    }).filter(Boolean);

    if (!headings.length) return null;

    var activeLink = null;
    var clickLocked = false; // while true the observer must not move the highlight
    var visibleSet = new Set(); // headings currently in the viewport

    function activate(link) {
      if (link === activeLink) return;
      if (activeLink) activeLink.classList.remove('toc-active');
      if (link) {
        link.classList.add('toc-active');
        // Scroll the ToC nav so the active link stays visible
        if (tocNav.scrollHeight > tocNav.clientHeight) {
          var li = link.closest('li') || link;
          var top = li.offsetTop;
          var center = top - tocNav.clientHeight / 2 + li.offsetHeight / 2;
          tocNav.scrollTo({ top: Math.max(0, center), behavior: 'smooth' });
        }
      }
      activeLink = link;
    }

    function linkFor(id) {
      return tocNav.querySelector('a[href="#' + id + '"]');
    }

    var controller = {
      // Highlight the clicked entry now and freeze it until unlock().
      lock: function(id) {
        clickLocked = true;
        var link = linkFor(id);
        if (link) activate(link);
      },
      // Release the freeze; the clicked entry stays highlighted, the observer
      // takes over again with the reader's next scroll.
      unlock: function() {
        clickLocked = false;
      }
    };

    // Sidebar ToC click: lock the highlight on the clicked entry for the
    // whole smooth scroll — no more flicking through every section on the way.
    tocLinks.forEach(function(link) {
      bindTocLink(link, function(target) {
        controller.lock(target.id);
        scrollToHeading(target, controller.unlock);
      });
    });

    var observer = new IntersectionObserver(function(entries) {
      // Update visibility state for each reported heading
      entries.forEach(function(entry) {
        var id = entry.target.getAttribute('id');
        if (entry.isIntersecting) {
          visibleSet.add(id);
        } else {
          visibleSet.delete(id);
        }
      });

      // Don't override during click navigation
      if (clickLocked) return;

      // Find the topmost visible heading (in DOM order)
      var topmost = null;
      for (var i = 0; i < headings.length; i++) {
        if (visibleSet.has(headings[i].getAttribute('id'))) {
          topmost = headings[i];
          break;
        }
      }

      if (topmost) activate(linkFor(topmost.getAttribute('id')));
    }, {
      rootMargin: '0px 0px -40% 0px',
      threshold: 0
    });

    headings.forEach(function(h) { observer.observe(h); });

    return controller;
  }

  // ── ToC-click CLS compensation ─────────────────────────────────
  // After the browser's anchor scroll, watch images above the target.
  // As each lazy image loads it pushes content down — re-scroll to keep
  // the target heading aligned with the page's anchor-scroll offset.
  // The offset comes from `scroll-padding-block-start` set on <html>
  // (= sticky-area-height + 20px in theme.css), with any per-target
  // `scroll-margin-top` added on top. Reading these matches what the
  // browser itself uses for hash navigation, so the re-scroll lands
  // headings at the same position as the initial click.
  // User-initiated scroll cancels compensation so we never fight the user.
  // Safety timeout cleans up listeners after 5s.
  function compensateClsToTarget(target) {
    var allImgs = Array.from(document.querySelectorAll('img'));
    var targetTop = target.getBoundingClientRect().top + window.scrollY;

    var pendingImgs = allImgs.filter(function(img) {
      if (img.complete) return false;
      var imgTop = img.getBoundingClientRect().top + window.scrollY;
      return imgTop < targetTop;
    });

    if (!pendingImgs.length) return;

    var cancelled = false;
    var pendingCount = pendingImgs.length;

    function cleanup() {
      window.removeEventListener('wheel', onUserScroll);
      window.removeEventListener('touchstart', onUserScroll);
      window.removeEventListener('keydown', onUserScroll);
    }
    function onUserScroll() { cancelled = true; cleanup(); }

    // Defer one frame so the browser's anchor scroll lands first; only then
    // start treating new scroll events as "user wants to cancel".
    requestAnimationFrame(function() {
      window.addEventListener('wheel', onUserScroll, { passive: true, once: true });
      window.addEventListener('touchstart', onUserScroll, { passive: true, once: true });
      window.addEventListener('keydown', onUserScroll, { passive: true, once: true });
    });

    function recheck() {
      if (cancelled) return;
      var rect = target.getBoundingClientRect();
      var drift = rect.top - getDesiredTop(target);
      if (Math.abs(drift) > 2) {
        window.scrollBy({ top: drift, behavior: 'instant' });
      }
    }

    var safetyTimer = setTimeout(function() { cancelled = true; cleanup(); }, 5000);

    pendingImgs.forEach(function(img) {
      function onSettled() {
        img.removeEventListener('load', onSettled);
        img.removeEventListener('error', onSettled);
        pendingCount--;
        recheck();
        if (pendingCount === 0) {
          clearTimeout(safetyTimer);
          cleanup();
        }
      }
      img.addEventListener('load', onSettled);
      img.addEventListener('error', onSettled);
    });
  }

  // Expose so pl-share-quote.js can reuse this for hash-share landings.
  window.plCompensateClsToTarget = compensateClsToTarget;

  // ── Init ───────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initToC);
  } else {
    initToC();
  }
})();
